import { LoggedInUserDto } from 'gleblu-socket-api';
import moment from 'moment';

import LoggedInUser from '../interfaces/LoggedInUser';

export function fromDto(loggedInUserDto: LoggedInUserDto): LoggedInUser {
  const { userUuid, companyUuid, companyPermission, placePermissions, name, passwordChangeRequired, deletionRequestedAt } = loggedInUserDto;
  return {
    userUuid,
    companyUuid,
    companyPermission,
    placePermissions: placePermissions.map(({ uuid, placeUuid, userUuid: permissionUserUuid, reservationPermission, settingPermission }) => ({
      uuid,
      placeUuid,
      userUuid: permissionUserUuid,
      reservationPermission,
      settingPermission,
    })),
    name,
    passwordChangeRequired,
    deletionRequestedAt: deletionRequestedAt != null ? moment(deletionRequestedAt) : null,
  };
}

export function toDto(_: LoggedInUser): LoggedInUserDto {
  throw new Error('Not implemented');
}
